type WebsitePublicConfig = {
  ui: {
    theme?: {
      defaultTheme?: 'default' | 'blue' | 'green' | 'amber' | 'neutral';
      enableSwitch?: boolean;
    };
    mode?: {
      defaultMode?: 'light' | 'dark' | 'system';
      enableSwitch?: boolean;
    };
  };
  metadata: {
    canonicalOrigin: string;
    images: {
      logoLight: string;
      logoDark?: string;
    };
    social?: {
      twitter?: string;
      github?: string;
      discord?: string;
      blueSky?: string;
      mastodon?: string;
      youtube?: string;
      linkedin?: string;
      facebook?: string;
      instagram?: string;
      tiktok?: string;
      telegram?: string;
    };
  };
  support: {
    email: string;
  };
  features: {
    enableDeferredHeaderUserControls?: boolean;
  };
  auth: {
    enableGoogleLogin: boolean;
  };
  i18n: {
    defaultLocale: string;
    locales: Record<
      string,
      {
        flag?: string;
        name: string;
        hreflang?: string;
      }
    >;
  };
  blog: {
    enable: boolean;
  };
  changelog: {
    enable: boolean;
  };
  credits: {
    enableCredits: boolean;
  };
};

/**
 * Client-safe subset of website configuration used by shared layout components.
 *
 * Keep this file focused on small, static fields that are safe to ship on
 * marketing and auth entry chunks.
 */
export const websitePublicConfig: WebsitePublicConfig = {
  ui: {
    theme: {
      defaultTheme: 'default',
      enableSwitch: true,
    },
    mode: {
      defaultMode: 'dark',
      enableSwitch: false,
    },
  },
  metadata: {
    canonicalOrigin: 'https://imgenhancer.app',
    images: {
      logoLight: '/android-chrome-96x96.png',
      logoDark: '/android-chrome-96x96.png',
    },
    social: {
      discord: 'https://discord.gg/xc7VcUsZDq',
    },
  },
  support: {
    email: 'hello@imgenhancer.app',
  },
  features: {
    enableDeferredHeaderUserControls: true,
  },
  auth: {
    enableGoogleLogin: true,
  },
  i18n: {
    defaultLocale: 'en',
    locales: {
      en: {
        name: 'English',
        hreflang: 'en',
      },
      'pt-br': {
        name: 'Português',
        hreflang: 'pt-BR',
      },
      de: {
        name: 'Deutsch',
        hreflang: 'de',
      },
      fr: {
        name: 'Français',
        hreflang: 'fr',
      },
      ja: {
        name: '日本語',
        hreflang: 'ja',
      },
      ko: {
        name: '한국어',
        hreflang: 'ko',
      },
      it: {
        name: 'Italiano',
        hreflang: 'it',
      },
      es: {
        name: 'Español',
        hreflang: 'es',
      },
      pl: {
        name: 'Polski',
        hreflang: 'pl',
      },
      'zh-hant': {
        name: '繁體中文',
        hreflang: 'zh-Hant',
      },
      zh: {
        name: '简体中文',
        hreflang: 'zh-CN',
      },
      tr: {
        name: 'Türkçe',
        hreflang: 'tr',
      },
      ar: {
        name: 'العربية',
        hreflang: 'ar',
      },
      id: {
        name: 'Bahasa Indonesia',
        hreflang: 'id',
      },
    },
  },
  blog: {
    enable: false,
  },
  changelog: {
    enable: true,
  },
  credits: {
    enableCredits: true,
  },
};
